var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 15",
    focusable: "false",
    className: "chakra-icon css-xzoyth",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5625 5.79358V4.25C9.5625 2.285 7.965 0.6875 6 0.6875C4.035 0.6875 2.4375 2.285 2.4375 4.25V5.79358C1.314 5.96833 0.75 6.70175 0.75 8V12.5C0.75 14 1.5 14.75 3 14.75H9C10.5 14.75 11.25 14 11.25 12.5V8C11.25 6.70175 10.686 5.96833 9.5625 5.79358ZM6.5625 10.2403V11.75C6.5625 12.0605 6.3105 12.3125 6 12.3125C5.6895 12.3125 5.4375 12.0605 5.4375 11.75V10.2214C5.2215 10.0497 5.07367 9.79625 5.07367 9.5C5.07367 8.9825 5.49001 8.5625 6.00751 8.5625H6.01501C6.53251 8.5625 6.95251 8.9825 6.95251 9.5C6.95251 9.809 6.79275 10.07 6.5625 10.2403ZM8.4375 5.75H3.5625V4.25C3.5625 2.9075 4.6575 1.8125 6 1.8125C7.3425 1.8125 8.4375 2.9075 8.4375 4.25V5.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockClosed);
export default __webpack_public_path__ + "static/media/lockClosed.247c4148c7155965dd42eb03d4d2d467.svg";
export { ForwardRef as ReactComponent };